<template>
  <header class="header" id="header">
    <b-navbar toggleable="md" type="primary">
      <b-navbar-brand class="header-logo" href="https://fivestones.net/" target="_blank"
        ><img src="./../assets/fs-logo.png" alt="" />
      </b-navbar-brand>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  background: #ffffff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  position: relative;
  &-logo {
    width: 33%;
    max-width: 120px;
    margin-top: 0px;
  }
  #nav-collapse {
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue